import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const driversOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.DRIVERS,
    steps: [
        {
            id: "drv-welcome",
            title: "Gestão de Motoristas",
            description:
                "Nesta tela você gerencia todos os motoristas cadastrados na plataforma. Vamos explorar os recursos disponíveis.",
            position: "center",
        },
        {
            id: "drv-table",
            title: "Lista de Motoristas",
            description:
                "Veja todos os motoristas com nome, telefone, status de aprovação e avaliação média. Clique em qualquer linha para ver os detalhes.",
            targetId: "drivers-table",
            position: "bottom",
        },
        {
            id: "drv-search",
            title: "Busca e Filtros",
            description:
                "Use o campo de busca para encontrar motoristas por nome ou telefone. Os filtros permitem segmentar por status de aprovação.",
            targetId: "drivers-search",
            position: "bottom",
        },
        {
            id: "drv-add",
            title: "Cadastrar Motorista",
            description:
                "Clique aqui para cadastrar um novo motorista manualmente. Motoristas também podem se cadastrar diretamente pelo app.",
            targetId: "drivers-add-btn",
            position: "left",
        },
        {
            id: "drv-actions",
            title: "Ações Rápidas",
            description:
                "Nas ações de cada motorista você pode aprovar/reprovar, editar dados e visualizar a documentação completa.",
            targetId: "drivers-actions",
            position: "left",
        },
    ],
};
